import { css } from '@emotion/css';

export const filterBodyStyle = css`
  .filter-items {
    min-height: 38.2rem;
    height: 38.2rem;
  }
`;
